import { ProductType } from '@/types';
import { getParams } from '@/utils/params';
import { fetchFromDesignerService } from './fetchFromDesignerService';

export const fetchFirstProductType = () =>
  fetchFromDesignerService<ProductType>('assortment/first', { shopId: getParams().contextId });
